export enum ChainId {
    MAINNET = "1",
    ROPSTEN = "3",
    RINKEBY = "4",
    GÖRLI = "5",
    KOVAN = "42",
    POLYGON = "137",
    MUMBAI = "80001",
    OKEX = "66",
    ARBITRUM = "42161",
    FANTOM = "250",
    OPTIMISM = "10",
    XDAI = "100",
    BSC = "56",
    HARMONY = "1666600000",
    AVALANCHE = "43114",
    FUJI = "43113"
}
export interface AssetType {
    name: string;
    symbol: string;
    decimals: string;
    address: string;
    chainId: string;
    logoURI: string;
    lpSymbol: string;
    lpAddress: string;
    stakingRewards: string;
    resourceId: string;
    lpResourceId: string;
    mappedOnBridge: boolean;
    native: boolean;
    hasLpToken: boolean;
    isLpToken: boolean;
    stableAsset: boolean;
    mining: boolean;
    activeMining: boolean;
    enableLiquidityMining: boolean;
  }
export interface TransactionStatus{"tx_status":string,
"tx_status_code":number,
"src_chain_id":string,
"dest_chain_id":string,
"src_tx_hash":string,
"dest_tx_hash":string}
export * from "./quote"